// extracted by mini-css-extract-plugin
export default {"numberFormat":"_2M_-AFTRPXDcjmVSZF1yPA"};